import { MainNavigation } from './MainNavigation';
import { AccountMenu } from './AccountMenu';
import { GettingStartedNav } from './GettingStartedNav';
import classes from './Sidebar.module.css';

type SidebarContentProps = {
  onNavigate?: () => void;
  collapsed?: boolean;
};

/** Innholdet i sidemenyen, felles for desktop og mobil. */
export const SidebarContent = ({ onNavigate, collapsed = false }: SidebarContentProps) => (
  <div className={classes.content}>
    <MainNavigation onNavigate={onNavigate} collapsed={collapsed} />
    <GettingStartedNav onNavigate={onNavigate} collapsed={collapsed} />
    <AccountMenu onNavigate={onNavigate} collapsed={collapsed} />
  </div>
);
